// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1vaPt","header":"MergedInvoice_header__2Q9ZT"};